
export default {

  storedMeetingKey: (state, getters, rootState) => (teamId) => {
    teamId = teamId || (rootState.currentTeam && rootState.currentTeam.id || 0);
    return `meetingData_${teamId}`;
  }

};
